module.exports = __webpack_public_path__ + "04_glasses_black.ee905937.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer4/04_glasses_black.png
// module id = Xif+
// module chunks = 0